import { StyleSheet } from 'react-native';
import type { RoleToken } from './roleTokenValues';
import { role } from './roleTokens';

/**
 * Web passthrough. `role` here is already a `var()` map (`roleTokens.web.ts`)
 * that the browser resolves via the `dark` class on `<html>`, so the factory
 * only ever needs to run once and this behaves exactly like the
 * `StyleSheet.create` call it replaces — no Proxy, no per-mode rebuild, no
 * subscription, no re-render on a flip. See `themedStyleSheet.ts` for why
 * native needs all of those.
 */
export function themedStyleSheet<T extends StyleSheet.NamedStyles<T>>(
  factory: (role: Record<RoleToken, string>) => T,
): T {
  return StyleSheet.create(factory(role));
}
